import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

import {PatchUpdateEmail, PatchUpdateEmailResponse, PostConfirmEmailParams} from 'domain/usecases';

export class RemotePatchUpdateEmail implements PatchUpdateEmail {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PatchUpdateEmailResponse>,
	) {}

	async patch(params: PostConfirmEmailParams): Promise<PatchUpdateEmailResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
